var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01192 12.4216C6.75309 12.4216 6.54917 12.3118 6.33741 12.053L4.14133 9.33924C4.03153 9.19022 3.96094 9.02552 3.96094 8.85297C3.96094 8.50002 4.23545 8.21767 4.58055 8.21767C4.79231 8.21767 4.98055 8.30395 5.15309 8.53924L6.9727 10.8922L10.5178 5.22159C10.659 4.9863 10.8551 4.86865 11.0668 4.86865C11.3962 4.86865 11.71 5.08826 11.71 5.44904C11.71 5.62159 11.6158 5.80199 11.5217 5.95885L7.64721 12.053C7.48251 12.2961 7.27074 12.4216 7.01192 12.4216Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5C12.3686 16.5 16 12.8765 16 8.5C16 4.13137 12.3608 0.5 7.99216 0.5C3.61569 0.5 0 4.13137 0 8.5C0 12.8765 3.62353 16.5 8 16.5ZM7.99614 15.3049C4.21741 15.3049 1.19922 12.2787 1.19922 8.5C1.19922 4.72927 4.2094 1.69507 7.98814 1.69507C11.7589 1.69507 14.7931 4.72927 14.8011 8.5C14.8091 12.2787 11.7669 15.3049 7.99614 15.3049Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckmarkCircle.844347a25e03f019fc5a397ec005420f.svg";